export default __webpack_public_path__ + "static/media/cafe.a9b04503.png";